<terra-main-nav></terra-main-nav>
<div class="container manage-users-header" fxLayoutAlign="space-between center">
    <div>
        <h1>Manage Users</h1>
    </div>
</div>
<div class="manage-users-content container">
    <div class="manage-users-body">
        <terra-user-and-permission-table></terra-user-and-permission-table>
    </div>
</div>